import { useEffect } from 'react'
import { isAdmin } from '../../../../../services/AccountService'
import {
  notifyError,
  notifySuccess,
} from '../../../../../services/ToastifyService/ToastifyService'
import { serviceCenterDefaultValues } from '../consts/diagnosticDrawer.consts'

export const useServiceResultsEffects = ({
  serialResponse,
  notifyRef,
  state,
  setters,
  form,
  store,
  resetState,
}: any) => {
  useEffect(() => {
    if (serialResponse?.receiver && !notifyRef.current) {
      handleSerialSuccess(serialResponse, notifyRef, setters, form, store)
    }
  }, [serialResponse?.receiver])

  useEffect(() => {
    if (serialResponse?.validationErrors) {
      handleSerialError(serialResponse, form, store)
    }
  }, [serialResponse?.validationErrors])

  useEffect(() => {
    if (
      store.serviceCenterData?.serialNumber &&
      store.isServerOrdersDrawerOpen &&
      store.existedRequestId
    ) {
      form.setValue('serialNumber', store.serviceCenterData?.serialNumber)
    } else if (!store.serviceCenterData?.serialNumber) {
      form.setValue('serialNumber', '')
    }
  }, [
    store.serviceCenterData?.serialNumber,
    store.isServerOrdersDrawerOpen,
    store.fromExistedRequest,
  ])

  useEffect(() => {
    const currentId = serialResponse?.receiver?.possibleMalfunctions?.find(
      (el: any) => el.name === form.watch('serviceCenterMalfunctionId')
    )
    if (currentId) {
      store.setServiceCenterMalfunctionTypeId(currentId.id)
    }
  }, [form.watch('serviceCenterMalfunctionId')])

  useEffect(() => {
    if (state.serialNum !== form.watch('serialNumber')) {
      setters.setSerialNum(null)
      setters.setChecked(false)
      setters.setMode('default')
      notifyRef.current = false
    }
  }, [form.watch('serialNumber')])

  useEffect(() => {
    if (store.resetAll) {
      resetState()
    }
  }, [store.resetAll])
}

const handleSerialSuccess = (
  serialResponse: any,
  notifyRef: any,
  setters: any,
  form: any,
  store: any
) => {
  notifySuccess('Операция выполнена успешно!')
  form.setValue('receiverModelName', serialResponse.receiver.name)
  form.setValue('serviceCenterMalfunctionId', '')

  setters.setChecked(true)

  const showFullForm =
    isAdmin() && store?.diagnosticData?.equipmentId !== 'Не заполнен'

  if (serialResponse?.receiver.activeRequest && showFullForm) {
    setters.setMode('has-active')
    setters.setSelectedServiceRequest(serialResponse?.receiver.activeRequest)
    store.setActiveServiceOrder(serialResponse?.receiver.activeRequest)
  } else if (serialResponse?.receiver.closedRequests.length && showFullForm) {
    store.setActiveServiceOrder(null)
    setters.setSelectedServiceRequest(null)
    setters.setMode('has-closed')
  } else {
    setters.setMode('checked')
    setters.setSelectedServiceRequest(null)
    store.setActiveServiceOrder(null)
  }

  notifyRef.current = true
}

const handleSerialError = (serialResponse: any, form: any, store: any) => {
  store.setActiveServiceOrder(null)
  notifyError(serialResponse?.validationErrors.join(', '))
  form.setValue(
    'serviceCenterMalfunctionId',
    serviceCenterDefaultValues.serviceCenterMalfunctionId
  )
}
